/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomMetricConfigurationListRequest {
    getFixupPrototypeFunction() { return CustomMetricConfigurationListRequest.fixupPrototype; }

    static newInstance(model: Partial<CustomMetricConfigurationListRequest>): CustomMetricConfigurationListRequest {
        let obj = Object.assign(new CustomMetricConfigurationListRequest(), model);
        CustomMetricConfigurationListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomMetricConfigurationListRequest>): CustomMetricConfigurationListRequest {
        if (!model) return null;
        return CustomMetricConfigurationListRequest.newInstance(<CustomMetricConfigurationListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomMetricConfigurationListRequest) {
        if (!obj) return;

        models.CustomMetricConfigurationListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomMetricConfigurationListRequest): boolean {
        Object.setPrototypeOf(obj, CustomMetricConfigurationListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.CustomMetricConfigurationListRequestContext.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.CustomMetricConfigurationListRequestSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.CustomMetricConfigurationListRequestSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.CustomMetricConfigurationListRequestContext;

}
